import React, { useState, useEffect, useCallback, useRef } from 'react';
import '../css/dataTablePopUp.css';
import ReactFlow, {
  ReactFlowProvider,
  addEdge,
  useNodesState,
  useEdgesState,
  Controls,
} from 'reactflow';
import Select from "react-select";

import {
  showCatalogSchemas, showCatalogSchemasTables, showCatalogSchemasTablesColumns, generateSQLData,
  fetchSqliteListTables, fetchSqliteListColumns
} from '../authorization/FetchToken';

import Spinner from '../Spinner'; // Import the Spinner component
import SearchableDropdown from '../SearchableDropdown';


const DataTablePopupComponent = ({ onClose, onRemoveTable, selectedNodeId, onValueSubmit,
  nodes, setNodes, droppedNodes, setDroppedNodes,
  nodeName, edges, setEdges,
  data, rightListValue, leftListValue, selectedWindowFunctionValue, selectedNestedWindowFunctionValue,
  selectedTableColumnsValue, orderByValue, partitionByValue,
  showWindowFunctionValue, selectedAdditionalWindowFunctionValue, selectedAdditionalNestedWindowFunctionValue,
  showAdditionalGroupInputsLength,
  selectedAdditionalCountsValue,
  additionalSelectedTableColumnsValue,
  additionalOrderByValue,
  additionalPartitionByValue,
  selectedCountValue, ntileInputValue,
  ntileAdditionalInputValue, catalogList, schemasList,
  tableList, columnList, columnTypeList, initialCatalog, initialTable, windowColumnList,
  initialCatalogList, initialSchemaList,
  initialTableList, initialColumnList, connectionType, connectionName, isFilterTableValueSame, isSelectedWindowFunction, windowFunctionsList
}) => {
  console.log("buildelect::-4.83", isSelectedWindowFunction)
  console.log("setDataTableNode::0", isFilterTableValueSame, selectedWindowFunctionValue, selectedNestedWindowFunctionValue,
    selectedTableColumnsValue, orderByValue, partitionByValue, showWindowFunctionValue, selectedAdditionalWindowFunctionValue, selectedAdditionalNestedWindowFunctionValue);

  const windowFunctions = [
    // { value: '', label: 'Select a window function' },
    //{ value: '-', label: '-' },
    { value: 'ROW_NUMBER', label: 'ROW_NUMBER' },
    { value: 'RANK', label: 'RANK' },
    { value: 'DENSE_RANK', label: 'DENSE_RANK' },
    { value: 'NTILE', label: 'NTILE()' },
    { value: 'MIN', label: 'MIN()' },
    { value: 'MAX', label: 'MAX()' },
    { value: 'SUM', label: 'SUM()' },
    { value: 'COUNT', label: 'COUNT()' },
    { value: 'AVG', label: 'AVG()' },
    { value: 'LEAD', label: 'LEAD()' },
    { value: 'LAG', label: 'LAG()' },
    { value: 'PERCENTAGE_COUNT', label: 'PERCENTAGE_COUNT' },
    { value: 'PERCENTAGE_SUM', label: 'PERCENTAGE_SUM' },
    { value: `date_format(date, '%d') AS date`, label: 'FORMAT_DATE_DAY' },
    { value: `date_format(date, '%M') AS month_name`, label: 'FORMAT_DATE_MONTH' },
    { value: `date_format(date, '%Y') AS year`, label: 'FORMAT_DATE_YEAR' },
    { value: "ROUND", label: 'ROUND' }

    // Add more window functions as needed
  ];
  const nestedFunctions = [
    // { value: '', label: 'Select a window function' },
    //{ value: '-', label: '-' },
    { value: "INTEGER", label: 'INTEGER' },
    { value: "BIGINT", label: 'BIGINT' },
    { value: "SMALLINT", label: 'SMALLINT' },
    { value: "REAL", label: 'REAL' },
    { value: 'DOUBLE', label: 'DOUBLE' },
    { value: 'VARCHAR', label: 'VARCHAR' },
    { value: 'TIMESTAMP', label: 'TIMESTAMP' },
    { value: 'TIME', label: 'TIME' },
    { value: 'DATE', label: 'DATE' },
    { value: `date_format(date, '%d')`, label: 'FORMAT_DATE_DAY' },
    { value: `date_format(date, '%M')`, label: 'FORMAT_DATE_MONTH' },
    { value: `date_format(date, '%Y')`, label: 'FORMAT_DATE_YEAR' },
    { value: "ROUND", label: 'ROUND' }

    // Add more window functions as needed
  ];
  useEffect(() => {

    if (catalogList.length > 0) {
      setCatalog(catalogList.map(catalog => catalog[0])); // Assuming catalogList is a two-dimensional array
    }
  }, [catalogList]);

  useEffect(() => {
    if (connectionType !== 'SQLite') {
      if (schemasList.length > 0) {
        setSelectedDatabase(schemasList.map(schema => schema[0]));
      }
    } else {
      if (schemasList.length > 0) {
        setSelectedDatabase(schemasList[0]);
      }
    }

  }, [schemasList]);

  useEffect(() => {
    if (connectionType !== 'SQLite') {
      if (tableList.length > 0) {
        setSelectedTable(tableList.map(table => table[0]));
      }
    } else {
      if (tableList.length > 0) {
        setSelectedTable(tableList[0]);
      }
    }
  }, [tableList]);

  const [catalogDataList, setCatalogDataList] = useState(catalogList.length > 0 ? catalogList : []);
  const [schemaDataList, setSchemaDataList] = useState(schemasList.length > 0 ? schemasList : []);
  const [tableDataList, setTableDataList] = useState(tableList.length > 0 ? tableList : []);
  const [columnDataList, setColumnDataList] = useState(columnList.length > 0 ? columnList : []);
  const [columnTypeListValue, setColumnTypeListValue] = useState(columnTypeList.length > 0 ? columnTypeList : []);
  const [windowColumnDataList, setWindowColumnDataList] = useState(columnList.length > 0 ? columnList : []);
  //const [isSelectedWindowFunctionChecked2, setIsSelectedWindowFunctionChecked2] = useState(isSelectedWindowFunction);
  const [isSelectedWindowFunction2, setIsSelectedWindowFunction2] = useState(isSelectedWindowFunction);
  //const [windowFunctionsList2, setWindowFunctionsList2] = useState(windowFunctionsList);
  //let windowFunctionsList2=[];
  //setIsSelectedWindowFunctionChecked2(isSelectedWindowFunctionChecked)
  //alert(JSON.stringify(leftListValue)+"leftListValue");
  const [name, setName] = useState(nodeName);
  //const [catalog, setCatalog] = useState(initialCatalog || (catalogList.length > 0 ? catalogList[0][0] : []));
  const [catalog, setCatalog] = useState(connectionName);
  console.log(JSON.stringify(catalog) + "catalog::11");


  const [selectedDatabase, setSelectedDatabase] = useState('');
  console.log("selectedDatabase::1", JSON.stringify(selectedDatabase));
  const [selectedTable, setSelectedTable] = useState('');
  console.log("selectedTable::1", JSON.stringify(selectedTable));

  //const [selectedTableColumns, setSelectedTableColumns] = useState([]);
  let [selectedTableColumns, setSelectedTableColumns] = useState(
    selectedTableColumnsValue && selectedTableColumnsValue.length > 0 ? selectedTableColumnsValue : "");

  console.log("selectedTableColumns::2", JSON.stringify(selectedTableColumnsValue));

  let [leftList, setLeftList] = useState(
    leftListValue && leftListValue.length > 0 ? leftListValue : columnList.length > 0 ? columnList : []);
  console.log("leftList::1", columnList, leftListValue);
  let [rightList, setRightList] = useState(
    rightListValue && rightListValue.length > 0 ? rightListValue : []
  );

  const [selectedWindowFunction, setSelectedWindowFunction] = useState(
    selectedWindowFunctionValue && selectedWindowFunctionValue.length > 0 ? selectedWindowFunctionValue : []);
  //let selectedNestedWindowFunctionValue;
  //let selectedAdditionalNestedWindowFunctionValue;
  const [selectedNestedWindowFunction, setSelectedNestedWindowFunction] = useState(
    selectedNestedWindowFunctionValue && selectedNestedWindowFunctionValue.length > 0 ? selectedNestedWindowFunctionValue : []);
  const [selectedAdditionalWindowFunction, setSelectedAdditionalWindowFunction]
    = useState(
      selectedAdditionalWindowFunctionValue && selectedAdditionalWindowFunctionValue.length > 0 ?
        selectedAdditionalWindowFunctionValue : []);
  const [selectedAdditionalNestedWindowFunction, setSelectedAdditionalNestedWindowFunction]
    = useState(
      selectedAdditionalNestedWindowFunctionValue && selectedAdditionalNestedWindowFunctionValue.length > 0 ?
        selectedAdditionalNestedWindowFunctionValue : []);

  const [showWindowFunction, setShowWindowFunction] = useState(
    showWindowFunctionValue && showWindowFunctionValue !== undefined ? showWindowFunctionValue : false);

  //const [partitionBy, setPartitionBy] = useState(
  //partitionByValue && partitionByValue.length > 0 ? partitionByValue : ' ');
  const [partitionBy, setPartitionBy] = useState(
    partitionByValue && partitionByValue.length > 0 ? partitionByValue : '');
  console.log("orderBy::1", orderByValue);
  const [orderBy, setOrderBy] = useState(
    orderByValue && orderByValue.length > 0 ? orderByValue : '');
  console.log("orderBy::1.5", JSON.stringify(orderBy));
  const [isDropdownVisible, setIsDropdownVisible] = useState(true);
  const [ntileValue, setNtileValue] = useState(ntileInputValue && ntileInputValue.length > 0 ? ntileInputValue : '');
  const [ntileAdditionalValue, setNtileAdditionalValue] = useState(ntileAdditionalInputValue &&
    ntileAdditionalInputValue.length > 0 ? ntileAdditionalInputValue : []);

  const [showOptions, setShowOptions] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCount, setSelectedCount] = useState(
    selectedCountValue && selectedCountValue !== undefined && selectedCountValue !== '' ? selectedCountValue : 0);
  const [showAdditionalGroupInputs, setShowAdditionalGroupInputs] = useState([]);
  const [showAdditionalOptions, setShowAdditionalOptions] = useState({});

  const [additionalPartitionBy, setAdditionalPartitionBy] = useState([]);
  const [additionalOrderBy, setAdditionalOrderBy] = useState([]);
  console.log("orderBy::1.75", JSON.stringify(additionalOrderByValue));

  const [additionalSelectedTableColumns, setAdditionalSelectedTableColumns] = useState([]);
  const [selectedAdditionalCounts, setSelectedAdditionalCounts] = useState(
    selectedAdditionalCountsValue && selectedAdditionalCountsValue.length > 0 ? selectedAdditionalCountsValue : []);

  const [windowFunctionInput, setWindowFunctionInput] = useState('');
  const [FilterTableValueSame, setFilterTableValueSame] = useState(false);

  // cataloglist


  const [schemas, setSchemas] = useState([]);
  const [loading, setLoading] = useState(false);

  let localOrderBy = orderBy;
  useEffect(() => {
    if (connectionType !== 'SQLite') {
      // Set initial values based on SQLite data
      setOrderBy(orderBy)
      setSelectedDatabase(schemasList.length > 0 ? schemasList[0][0] : []);
      setSelectedTable(initialTable || (tableList.length > 0 ? tableList[0][0] : []));
      setSelectedTableColumns(
        selectedTableColumnsValue && selectedTableColumnsValue.length > 0
          ? selectedTableColumnsValue
          : columnList.length > 0
            //? columnList[0]
            ? []
            : []
      );
    } else {
      // Set initial values based on non-SQLite data
      setSelectedDatabase(schemasList.length > 0 ? schemasList[0] : []);
      setSelectedTable(initialTable || (tableList.length > 0 ? tableList[0] : []));
      setSelectedTableColumns(
        selectedTableColumnsValue && selectedTableColumnsValue.length > 0
          ? selectedTableColumnsValue
          : columnList.length > 0
            //? columnList[0]
            ? []
            : []
      );
    }

    console.log(JSON.stringify(selectedDatabase) + 'selectedDatabase');
    console.log(JSON.stringify(selectedTable) + 'selectedTable');
    console.log(JSON.stringify(selectedTableColumns) + 'selectedTableColumns');
  }, [connectionType, schemasList, tableList, selectedTableColumnsValue, columnList]);



  const toggleDropdowns = () => {
    setShowWindowFunction(!showWindowFunction);
  };


  const renderCatalogsOptions = () => {
    return catalogList.map((catalog, index) => (
      <option key={index} value={catalog}>
        {catalog}
      </option>
    ));
  };

  const renderSchemasOptions = () => {
    return schemaDataList.map((schema, index) => (
      <option key={index} value={schema}>
        {schema}
      </option>
    ));
  };

  const renderTable1Options = () => {
    return tableDataList.map((table, index) => (
      <option key={index} value={table}>
        {table}
      </option>
    ));
  };


  const handleCatalogChange = async (event) => {
    const catalog = event.target.value;

    let response = null;
    setLoading(true);
    try {
      response = await showCatalogSchemas(catalog);
      console.log(JSON.stringify(response[0][0]) + "response");
      if (response && response.length > 0) {
        setSelectedDatabase(response[0][0]);
        setSchemaDataList(response.map(schema => schema[0]));
        const catalogSchemaName = `${connectionName}.${response[0][0]}`;
        const tables = await showCatalogSchemasTables(catalogSchemaName);
        if (tables && tables.length > 0) {
          console.log(JSON.stringify(tables[0][0]) + "tables::1");
          setSelectedTable(tables[0][0]);
          setTableDataList(tables.map(table => table[0]));
          const catalogSchemaTableName = `${catalogSchemaName}.${tables[0][0]}`;
          try {
            const response = await showCatalogSchemasTablesColumns(catalogSchemaTableName);
            console.log(JSON.stringify(response[0][0]) + "columnname");
            if (response && response.length > 0) {
              setLeftList(response.map(leftList => leftList[0]));
              setColumnDataList(response.map(leftList => leftList[0]));
              setRightList([]);
              setSelectedTableColumns(response[0][0]);
              setOrderBy(response[0][0]);
              setPartitionBy(response[0][0]);
              setColumnTypeListValue(response);
            }
          } catch (error) {
            console.error('Error fetching dropdown options:', error);
          }

        }
      }
    } catch (error) {
      console.error('Error fetching dropdown options:', error);
    }
    console.log(JSON.stringify(response) + "list of schemas");
    //setCatalog(catalog);
    setCatalog(connectionName)
    setLoading(false);
  };


  const handleDatabaseChange = async (event) => {
    const schema = event.target.value;
    var message_list = []

    setLoading(true);
    setSelectedDatabase(schema);
    if (connectionType !== 'SQLite') {
      //const catalogSchemaName = `${catalog}.${schema}`;
      const catalogSchemaName = `${connectionName}.${schema}`;
      try {
        const response = await showCatalogSchemasTables(catalogSchemaName);
        console.log(JSON.stringify(response) + "response");
        if (response && response.length > 0) {
          setSelectedTable(response[0][0]);
          setTableDataList(response.map(table => table[0]));
          const catalogSchemaTableName = `${connectionName}.${schema}.${response[0][0]}`;
          try {
            const response = await showCatalogSchemasTablesColumns(catalogSchemaTableName);
            console.log(JSON.stringify(response.map(leftList => leftList[0])) + "columns::");
            if (response && response.length > 0) {
              if (JSON.stringify(response.map(leftList => leftList[0])).includes("_message")) {
                const response = await generateSQLData(`select _message from ${catalogSchemaTableName}`)
                console.log("_message:data::", Object.keys(JSON.parse(response.data[0])))
                message_list = Object.keys(JSON.parse(response.data[0])).map(elem => "_message_" + elem)
              }
              console.log("_message:data2::", response.map(leftList => leftList[0]))
              const columnList = message_list.concat(response.map(leftList => leftList[0]));
              setWindowColumnDataList(columnList);
              setLeftList(columnList);
              setColumnDataList(columnList)
              setRightList([]);
              setColumnTypeListValue(response);
              setSelectedTableColumns([]);
              setOrderBy([]);
              setShowWindowFunction(false);
              setPartitionBy([]);

            }
          } catch (error) {
            console.error('Error fetching dropdown options:', error);
          }

        }
      } catch (error) {
        console.error('Error fetching dropdown options:', error);
      }
    } else {
      let tableNames = [];
      let columnNames = [];
      tableNames = await fetchSqliteListTables(schema);
      console.log(JSON.stringify(tableNames) + "tableNames");
      setSelectedTable(tableNames[0]);
      setTableDataList(tableNames);
      if (tableNames && tableNames.length > 0) {
        console.log(JSON.stringify(tableNames[0]) + "tableNames");
        columnNames = await fetchSqliteListColumns(schema, tableNames[0]);
        console.log(JSON.stringify(columnNames) + "columnNames");

        setLeftList(columnNames.map(leftList => leftList[0]));
        setColumnDataList(columnNames.map(column => column[0]));
        setRightList([]);
        setSelectedTableColumns(columnNames[0]);
        setColumnTypeListValue(columnNames);
        //setOrderBy(columnNames[0][0]);
        setOrderBy();
        setShowWindowFunction(false);
        //setPartitionBy(columnNames[0][0]);
        setPartitionBy();
      }
    }
    isFilterTableValueSame = false;
    setLoading(false);
  };

  var window_column_list = [];
  const handleTableChange = async (event, selectedTable) => {
    const selectedTableName = event.target.value;
    console.log("selectedTableName::2", selectedTableName)
    setLoading(true);
    setSelectedTable(selectedTableName);
    if (connectionType !== 'SQLite') {
      //const catalogSchemaTableName = `${catalog}.${selectedDatabase}.${selectedTableName}`;
      const catalogSchemaTableName = `${connectionName}.${selectedDatabase}.${selectedTableName}`;
      let message_list = [];
      try {
        const response = await showCatalogSchemasTablesColumns(catalogSchemaTableName);
        console.log(JSON.stringify(response.map(leftList => leftList[0])) + "columns::11");
        if (response && response.length > 0) {
          if (JSON.stringify(response.map(leftList => leftList[0])).includes("_message")) {
            const response = await generateSQLData(`select _message from ${catalogSchemaTableName}`)
            console.log("_message:data::", Object.keys(JSON.parse(response.data[0])))
            message_list = Object.keys(JSON.parse(response.data[0])).map(elem => "_message_" + elem)
          }
          console.log("_message:data2::", response.map(leftList => leftList[0]))
          const columnList = message_list.concat(response.map(leftList => leftList[0]));
          window_column_list = message_list.concat(response.map(leftList => leftList[0]));
          console.log("_message:data3::", response)
          setLeftList(columnList);
          setRightList([]);
          //  const columns = selectedTable.columns;
          //setSelectedTableColumns(response[0][0]);
          setSelectedTableColumns();
          //setSelectedTableColumns(window_column_list);
          setColumnDataList(window_column_list)
          setRightList([]);
          setColumnTypeListValue(response);
          //setOrderBy(response[0][0]);
          setOrderBy();
          setShowWindowFunction(false);
          //setPartitionBy(response[0][0]);
          setPartitionBy();
          //selectedNestedWindowFunction([])
          //selectedAdditionalNestedWindowFunction([])
          console.log("selectedTableColumns::3", selectedTableColumns)

        }
      } catch (error) {
        console.error('Error fetching dropdown options:', error);
      }

    } else {
      let columnNames = [];
      columnNames = await fetchSqliteListColumns(selectedDatabase, selectedTableName);
      console.log(JSON.stringify(columnNames) + "columnNames");
      setLeftList(columnNames.map(leftList => leftList[0]));
      setColumnDataList(columnNames.map(column => column[0]));
      setRightList([]);
      setSelectedTableColumns(columnNames[0]);
      setColumnTypeListValue(columnNames);
      setOrderBy(columnNames[0][0]);
      setShowWindowFunction(false);
      setPartitionBy(columnNames[0][0]);

    }
    //isFilterTableValueSame = false;
    setFilterTableValueSame(false)
    console.log("isFilterTableValueSame::1", FilterTableValueSame)
    setLoading(false);
  };


  const renderTableColumnOptions = () => {
    var col_list = [];
    if (windowColumnDataList.includes("_message")) {
      console.log("In renderTableColumnOptions22::", windowColumnDataList);
      col_list = windowColumnDataList
      console.log("In renderTableColumnOptions77::", windowColumnDataList);

    } else {
      col_list = columnDataList
    }
    console.log("In renderTableColumnOptions33::", col_list)
    const columnOptions = col_list.map((column) => (
      <option key={column} value={column}>
        {column}
      </option>
    ));
    // Include an option with an empty string value and label
    const emptyStringOption = (
      <option key="" value="">
        -
      </option>
    );
    // Concatenate the column options and the empty string option
    console.log("In renderTableColumnOptions77::", [emptyStringOption, ...columnOptions])
    return [emptyStringOption, ...columnOptions];
  };



  const renderTableColumnOptions2 = () => {
    var col_list = [];
    var final_col_list = [];
    if (windowColumnDataList.some((item) => item.includes('_message'))) {
      console.log("In renderTableColumnOptions::22", windowColumnDataList);
      col_list = windowColumnDataList
      console.log("In renderTableColumnOptions::33", windowColumnDataList);

    } else {
      col_list = columnDataList
    }
    console.log("In renderTableColumnOptions::44", col_list)
    // Concatenate the column options and the empty string option
    const columnOptions = col_list.map((column, index) => (
      //console.log("In renderTableColumnOptions::55", column, index)
      //final_col_list.push({value:column})
      { label: column, value: column }
    ))
    console.log("In renderTableColumnOptions::55", columnOptions)
    return columnOptions;
  };

  const orderBYCols = renderTableColumnOptions2();


  const handleWindowFunctionChange = (event) => {
    event.stopPropagation(); // Stop event propagation
    const { value } = event.target;
    console.log(value + "value");
    setSelectedWindowFunction(value);

    // If 'OTHERS' is selected, clear the windowFunctionInput value
    if (value === 'OTHERS') {
      setWindowFunctionInput('');

    }

  };
  const handleWindowFunctionInputChange = (event) => {
    const inputValue = event.target.value;
    setWindowFunctionInput(inputValue);
  };

  useEffect(() => {

    setName(nodeName);
    //setCatalog(catalog);
    setCatalog(connectionName);

    const selectedNode = nodes.find((node) => node.id === selectedNodeId);
    console.log(JSON.stringify(selectedNode) + "selectedNode::11");
    if (selectedNode) {
      // Update the selectedDatabase and selectedTable states based on the selected node's values
      setCatalog(selectedNode.data.catalog);
      setSelectedDatabase(selectedNode.data.selectedDatabase);
      setSelectedTable(selectedNode.data.selectedTable);
      setSelectedTableColumns(selectedNode.data.columns);
    }

    if (rightListValue && rightListValue.length > 0) {
      console.log(JSON.stringify(rightListValue) + "rightListValue");
      const formattedRightList = rightListValue.map((column) => {
        const columnName = column.split('.').pop().replace(')', '');
        return columnName;
      });

      setRightList(formattedRightList);
      // setSelectedWindowFunction(selectedWindowFunction);
      setSelectedWindowFunction(rightListValue.reduce((acc, column) => {
        const columnName = column.split('.').pop().replace(')', '');
        const [windowFunction] = column.match(/\w+/);
        acc[columnName] = windowFunction;
        return acc;
      }, {}));
      console.log(JSON.stringify(leftListValue) + "leftListValue");
      setLeftList(leftList);

    } else {
      setRightList([]);
    }
    if (leftListValue && leftListValue.length > 0) {
      setLeftList(leftList);
    } else if (leftListValue && leftListValue.length === 0) {
      setLeftList([]);
    } else {
      setLeftList(columnList || []);
    }

    if (showWindowFunctionValue) {
      console.log("In showWindowFunctionValue::1")
      setSelectedWindowFunction(selectedWindowFunctionValue);
      setSelectedNestedWindowFunction(selectedNestedWindowFunctionValue);
      setSelectedTableColumns(selectedTableColumnsValue);
      //setSelectedTableColumns('-');
      setOrderBy(orderByValue);
      setPartitionBy(partitionByValue);
      setSelectedCount(selectedCountValue);
      setNtileValue(ntileInputValue);

      setShowAdditionalGroupInputs(showAdditionalGroupInputsLength > 0 ? [{}] : []);
      if (showAdditionalGroupInputsLength > 0) {
        setSelectedAdditionalWindowFunction(selectedAdditionalWindowFunctionValue);
        setSelectedAdditionalNestedWindowFunction(selectedAdditionalNestedWindowFunctionValue);
        setAdditionalSelectedTableColumns(additionalSelectedTableColumnsValue);
        setAdditionalOrderBy(additionalOrderByValue);
        setAdditionalPartitionBy(additionalPartitionByValue);
        setSelectedAdditionalCounts(selectedAdditionalCountsValue);
        setNtileAdditionalValue(ntileAdditionalInputValue);

      } else {
        // If showAdditionalGroupInputs is empty, reset the values to initial state or empty arrays
        setSelectedAdditionalWindowFunction([]);
        setSelectedAdditionalNestedWindowFunction([]);
        setAdditionalSelectedTableColumns([]);
        setAdditionalOrderBy([]);
        setAdditionalPartitionBy([]);
        setSelectedAdditionalCounts([]);
        setNtileAdditionalValue([]);
      }

    }

  }, [nodeName], [selectedNodeId], [nodes], [rightList], [leftList], [additionalPartitionBy],
    [showAdditionalGroupInputsLength], [selectedAdditionalWindowFunctionValue], [selectedAdditionalNestedWindowFunctionValue], [additionalSelectedTableColumnsValue], [additionalOrderByValue], [additionalPartitionByValue], [selectedAdditionalCountsValue]);

  console.log(selectedNodeId + selectedCountValue + "selectedNodeId::1");

  // Example usage: Handle dropped nodes and update the state
  const handleDrop = (droppedNodes) => {
    // Perform any necessary operations with the dropped nodes
    // ...
    setDroppedNodes(droppedNodes); // Call the setDroppedNodes function to update the dropped nodes in the parent component
  };

  const handleRemoveTable = () => {
    // Call the onRemoveTable callback function
    var newNodes = []
    var newEdges = []
    var newDroppedNodes = []
    //console.log("onRemoveTable::1", nodes[0]["id"], selectedNodeId)
    if (onRemoveTable) {
      newNodes = nodes.filter((node) => node["id"] != selectedNodeId);
      newEdges = edges.filter((edge) => !edge["id"].includes(`-${selectedNodeId}`));
      //edataTable_1-
      for (let i = 0; i < droppedNodes.length; i++) {
        if (droppedNodes[i] === selectedNodeId) {
          droppedNodes.splice(i, 1);
          console.log("Remaining elements: " + droppedNodes);
        }
      }
      //newDroppedNodes = droppedNodes.filter(!selectedNodeId)
      console.log("onRemoveTable::2", newNodes, selectedNodeId, edges, newEdges, newDroppedNodes)
      onRemoveTable();
    }
    // Close the popup
    setNodes(newNodes)
    setEdges(newEdges)
    setDroppedNodes(droppedNodes)
    //onClose(nodes)
  };

  const handleSubmit = (event) => {
    let windowFunctionWithColumn;
    let selectOrderByValue = '';
    let selectPartitionByValue = '';
    let appendWindowFunction;
    let aliasColumnNames = '';
    let aliasFunctionNames = '';
    let windowFunctionWithCondition = '';
    let formattedRightList = '';
    let formattedLeftList = '';
    let columnsWithCatalogs = '';
    console.log(JSON.stringify(selectedDatabase) + "selectedDatabase");
    console.log(JSON.stringify(selectedTable) + "selectedTable");
    console.log("selectedTableColumns::4", JSON.stringify(selectedTableColumns));
    console.log(JSON.stringify(catalog) + "catalog");
    console.log(JSON.stringify(selectedDatabase) + "selectedDatabase");
    console.log(JSON.stringify(selectedTable) + "selectedTable");
    console.log("orderBy::2", JSON.stringify(orderBy), JSON.stringify(partitionBy), additionalOrderBy, additionalPartitionBy);
    console.log(JSON.stringify(partitionBy) + "partitionby************");
    console.log("additionalOrderBy::10", JSON.stringify(additionalOrderBy));
    console.log(JSON.stringify(additionalPartitionBy) + "partitionby");
    console.log(JSON.stringify(additionalPartitionBy) + "ADDitionalpartitionby***********");
    console.log(JSON.stringify(additionalSelectedTableColumns) + "additionalSelectedTableColumns");
    console.log(JSON.stringify(selectedAdditionalWindowFunction) + "selectedAdditionalWindowFunction");
    console.log(JSON.stringify(selectedWindowFunction) + "selectedWindowFunction::11");
    console.log(JSON.stringify(showWindowFunction) + "showWindowFunction::11");

    if (connectionType !== 'SQLite') {
      formattedRightList = rightList.map((column) => `${catalog}.${selectedDatabase}.${selectedTable}.${column}`);
      formattedLeftList = leftList.map((column) => `${catalog}.${selectedDatabase}.${selectedTable}.${column}`);
      columnsWithCatalogs = columnDataList.map((column) => `${catalog}.${selectedDatabase}.${selectedTable}.${column}`);

    } else {
      formattedRightList = rightList.map((column) => `${selectedTable}.${column}`);
      formattedLeftList = leftList.map((column) => `${selectedTable}.${column}`);
      columnsWithCatalogs = columnDataList.map((column) => `${selectedTable}.${column}`);

    }

    console.log(JSON.stringify(schemaDataList) + "schemaDataList");

    let combinedSelectedTableColumns = [];
    let combinedOrderBy = '';
    let combinedPartitionBy = '';
    let aliasColumnsAndTypes = '';
    if (showWindowFunction) {
      console.log("In showWindowFunction::2", JSON.stringify(selectedWindowFunction), JSON.stringify(selectedAdditionalWindowFunction))

      // Add the first column of selectFiltercolumns to selectGroupColumns
      const combinedWindowFunctions = [selectedWindowFunction, ...selectedAdditionalWindowFunction];
      const combinedNestedWindowFunctions = [selectedNestedWindowFunction, ...selectedAdditionalNestedWindowFunction];
      const combinedSelectedTableColumnsValue = [selectedTableColumns, ...additionalSelectedTableColumns];
      if (combinedSelectedTableColumnsValue.length > 0) {
        // Use the filter method to get non-empty values
        const nonEmptyValues = additionalSelectedTableColumns.filter((column) => column !== '');

        console.log("In buildelect::-5", combinedSelectedTableColumnsValue, selectedTableColumns, additionalSelectedTableColumns, nonEmptyValues)
        if (selectedTableColumns === "" && additionalSelectedTableColumns.length === 0) {
          combinedSelectedTableColumns = [];
        } else if (selectedTableColumns !== '' || nonEmptyValues.length > 0) {
          if (connectionType !== 'SQLite') {
            if (connectionType == 'kafka') {
              console.log("combinedSelectedTableColumns::0", combinedSelectedTableColumnsValue)
              combinedSelectedTableColumnsValue.map((column) => {
                console.log("combinedSelectedTableColumns::0.5", column.includes("_message_"))
                if (column.includes("_message_")) {
                  console.log("combinedSelectedTableColumns::1", column)
                  column = 'json_extract_scalar(' + `${catalog}.${selectedDatabase}.${selectedTable}._message` + ',' + "'$." + `${column}`.split('_message_')[1] + "') AS " + `${column}`
                  combinedSelectedTableColumns.push(column)
                } else {
                  console.log("combinedSelectedTableColumns::2", `${catalog}.${selectedDatabase}.${selectedTable}.${column}`)
                  combinedSelectedTableColumns.push(`${catalog}.${selectedDatabase}.${selectedTable}.${column}`)
                }

              }
              );

            } else {
              combinedSelectedTableColumns = combinedSelectedTableColumnsValue.map((column) => `${catalog}.${selectedDatabase}.${selectedTable}.${column}`);
            }

          } else {
            combinedSelectedTableColumns = combinedSelectedTableColumnsValue.map((column) => `${selectedTable}.${column}`);

          }

        }
      }
      console.log("additionalOrderBy::3", orderBy, additionalOrderBy, combinedSelectedTableColumns)

      const combinedOrderByValues = [orderBy, ...additionalOrderBy];
      if (combinedOrderByValues.length > 0) {
        // Use the filter method to get non-empty values
        console.log("additionalOrderBy::1", combinedOrderByValues.length, JSON.stringify(combinedOrderByValues))
        const emptyAdditionalOrderByValues = additionalOrderBy.filter((column) => column === '');
        if (orderBy == undefined || orderBy.length == 0 && emptyAdditionalOrderByValues.length > 0) {
          combinedOrderBy = "";
        } else if (orderBy.length > 0 || additionalOrderBy.length > 0) {
          console.log("additionalOrderBy::2", orderBy.length, additionalOrderBy, additionalOrderBy.length, typeof orderBy)
          if (connectionType !== 'SQLite') {
            if (connectionType == 'kafka') {
              combinedOrderBy = combinedOrderByValues.map((column) =>
                'json_extract_scalar(' + `${catalog}.${selectedDatabase}.${selectedTable}._message` + ',' + "'$." + `${column}`.split('_message_')[1] + "') AS " + `${column}`

              );

            } else {
              combinedOrderBy = combinedOrderByValues.map((column) => `${catalog}.${selectedDatabase}.${selectedTable}.${column}`);
            }

          } else {
            combinedOrderBy = combinedOrderByValues.map((column) => `${selectedTable}.${column}`);

          }

        }

      }
      const combinedPartitionByValues = [partitionBy, ...additionalPartitionBy];
      console.log("additionalPartitionBy::1", JSON.stringify(partitionBy), JSON.stringify(additionalPartitionBy))
      if (combinedPartitionByValues.length > 0) {
        const emptyAdditionalPartitionBy = additionalPartitionBy.some((element) => true);

        if (partitionBy == undefined || partitionBy.length === 0 && emptyAdditionalPartitionBy) {
          combinedPartitionBy = '';
        } else if (partitionBy.length > 0 || additionalPartitionBy.length > 0) {
          if (connectionType !== 'SQLite') {
            combinedPartitionBy = combinedPartitionByValues.map(columns => `${catalog}.${selectedDatabase}.${selectedTable}.${columns}`);

          } else {
            combinedPartitionBy = combinedPartitionByValues.map(columns => `${selectedTable}.${columns}`);

          }

        }
      }

      console.log("combinedWindowFunctions::11", combinedWindowFunctions)
      console.log(
        JSON.stringify(combinedSelectedTableColumns) + "combinedSelectedTableColumns" +
        JSON.stringify(combinedOrderBy) + "combinedOrderBy" +
        JSON.stringify(combinedPartitionBy) + "combinedPartitionBy");


      if (selectedWindowFunction && selectedTableColumns && selectedTableColumns !== '-' || selectedTableColumns === '') {

        windowFunctionWithCondition = combinedWindowFunctions.map((selectedWindowFn, index) => {
          console.log("windowFunctionWithCondition::-11", combinedWindowFunctions[index].length, index, combinedNestedWindowFunctions[index]);
          //if (selectedWindowFn !== "-" || selectedWindowFn !== " ") {
          if (selectedWindowFn !== "") {
            if (selectedWindowFn === "RANK" || selectedWindowFn === "DENSE_RANK" || selectedWindowFn === "ROW_NUMBER") {
              return `${selectedWindowFn}()`;
            } else if (selectedWindowFn === "NTILE" && index > 0) {
              return `${selectedWindowFn}(${ntileAdditionalValue})`;
            } else if (selectedWindowFn === "NTILE") {
              return `${selectedWindowFn}(${ntileValue})`;
            } else if (selectedWindowFn === "NTILE" && index > 0) {
              return `${selectedWindowFn}(${ntileAdditionalValue})`;
            } else if (selectedWindowFn === "PERCENTAGE_COUNT") {
              return ` 100.0 * COUNT(*) / SUM(COUNT(*)) OVER () AS percentage`;
            } else if (selectedWindowFn === "PERCENTAGE_SUM") {
              if (connectionType !== 'SQLite') {
                return `100.0 * SUM(${catalog}.${selectedDatabase}.${selectedTable}.${selectedTableColumns}) / SUM(SUM(${catalog}.${selectedDatabase}.${selectedTable}.${selectedTableColumns})) OVER () AS percentage`;

              } else {
                return `100.0 * SUM(${selectedTable}.${selectedTableColumns}) / SUM(SUM(${selectedTable}.${selectedTableColumns})) OVER () AS percentage`;

              }

            } else if (selectedWindowFn === "PERCENTAGE_SUM" && index > 0) {
              if (connectionType !== 'SQLite') {
                return `100.0 * SUM(${catalog}.${selectedDatabase}.${selectedTable}.${additionalSelectedTableColumns}) / SUM(SUM(${catalog}.${selectedDatabase}.${selectedTable}.${additionalSelectedTableColumns})) OVER () AS percentage`;

              } else {
                return `100.0 * SUM(${selectedTable}.${additionalSelectedTableColumns}) / SUM(SUM(${catalog}.${selectedDatabase}.${selectedTable}.${additionalSelectedTableColumns})) OVER () AS percentage`;

              }

            }
            else if (selectedWindowFn === "FORMAT_DATE_DAY") {
              // return `TO_CHAR(date, 'D') AS date`;
              // return `EXTRACT(DAY FROM CAST(date AS DATE)) AS day`;
              return `date_format(date, '%d') AS date`;
            } else if (selectedWindowFn === "FORMAT_DATE_DAY" && index > 0) {
              // return `TO_CHAR(date, 'D') AS date`;
              // return `EXTRACT(DAY FROM CAST(date AS DATE)) AS day`;
              return `date_format(date, '%d') AS date`;
            } else if (selectedWindowFn === "FORMAT_DATE_MONTH") {
              // return `TO_CHAR(date, 'month') AS extracted_month`;
              return `date_format(date, '%M') AS month_name`;
            } else if (selectedWindowFn === "FORMAT_DATE_MONTH" && index > 0) {
              //  return `TO_CHAR(date, 'month') AS extracted_month`;
              return `date_format(date, '%M') AS month_name`;
            } else if (selectedWindowFn === "FORMAT_DATE_YEAR") {
              // return `TO_CHAR(date, 'YYYY') AS extracted_year`;
              return `date_format(date, '%Y') AS year`;
            } else if (selectedWindowFn === "FORMAT_DATE_YEAR" && index > 0) {
              // return `TO_CHAR(date, 'YYYY') AS extracted_year`;
              return `date_format(date, '%Y') AS year`;
            } else if (selectedWindowFn === "ROUND" && selectedTableColumns !== '') {
              // return `TO_CHAR(date, 'YYYY') AS extracted_year`;
              console.log("buildelect::100", connectionType )
              if (connectionType !== 'SQLite') {
                if (connectionType == 'kafka') {
                  let col_part = `${catalog}.${selectedDatabase}.${selectedTable}.${selectedTableColumns}`.split('_message_')
                  console.log("buildelect::300", col_part)
                  let col_val = 'json_extract_scalar(' + col_part[0] + '_message,' + "'$." + col_part[1] + "') AS " + '_message_' + col_part[1];
                  return `ROUND(${col_val}, 2) AS rounded_${col_val}`;
                  } else {
                    return `ROUND(${catalog}.${selectedDatabase}.${selectedTable}.${selectedTableColumns}, 2) AS rounded${selectedTableColumns}`;
                  }
              } else {
                return `ROUND(${selectedTable}.${selectedTableColumns}, 2) AS rounded${selectedTableColumns}`;
              }

            } else if (selectedWindowFn === "ROUND" && index > 0) {
              // return `TO_CHAR(date, 'YYYY') AS extracted_year`;
              console.log("buildelect::200")
              if (connectionType !== 'SQLite') {
                return `ROUND(${catalog}.${selectedDatabase}.${selectedTable}.${additionalSelectedTableColumns}, 2) AS rounded${additionalSelectedTableColumns}`;

              } else {
                if (connectionType == 'kafka') {
                  let col_part = `${catalog}.${selectedDatabase}.${selectedTable}.${selectedTableColumns}`.split('_message_')
                  let col_val = 'json_extract_scalar(' + col_part[0] + '_message,' + "'$." + col_part[1] + "') AS " + '_message_' + col_part[1];
                  return `ROUND(${col_val}, 2) AS rounded_${col_val}`;
                } else {
                  return `ROUND(${selectedTable}.${additionalSelectedTableColumns}, 2) AS rounded${additionalSelectedTableColumns}`;

                }
                //return `ROUND(${selectedTable}.${additionalSelectedTableColumns}, 2) AS rounded${additionalSelectedTableColumns}`;

              }

            } else if (combinedSelectedTableColumns === '') {
              return `${selectedWindowFn}`;
            }
            /*
            else if (`${selectedWindowFn}`.includes("$")) {
              console.log("combinedWindowFunctions with $", selectedTableColumns)
              if (connectionType !== 'SQLite') {
                return `${ selectedWindowFn }`.replace("$",`${catalog}.${selectedDatabase}.${selectedTable}.${selectedTableColumns}`);

              } else {    
                return `${selectedWindowFn}`.replace("$",`${selectedTable}.${selectedTableColumns}`);

              }
            }
            */
            //else if (selectedWindowFn !== undefined && Object.keys(selectedWindowFn).length > 0) {
            else if (combinedWindowFunctions[index].length > 0) {
              console.log("windowFunctionWithCondition::-22", combinedNestedWindowFunctions[index].length, JSON.stringify(combinedNestedWindowFunctions[index]), JSON.stringify(combinedWindowFunctions), JSON.stringify(combinedSelectedTableColumns), index);
              //if (selectedNestedWindowFunction !== undefined && combinedNestedWindowFunctions[index].length > 0 && Object.keys(selectedNestedWindowFunction).length > 0) {
              //return selectedWindowFn + '(CAST(' + combinedSelectedTableColumns[index].split('AS')[0] + ' AS ' + combinedNestedWindowFunctions[index] + ' )) AS' + combinedSelectedTableColumns[index].split('AS')[1] + '_' + selectedWindowFn.toLowerCase()
              if (combinedNestedWindowFunctions[index].length > 0) {
                console.log("windowFunctionWithCondition::-22", combinedWindowFunctions[index].toLowerCase().split("($)")[0])
                if (combinedWindowFunctions[index].includes("$")) {
                  return combinedWindowFunctions[index].replace('$', 'CAST(' + combinedSelectedTableColumns[index].split('AS')[0] + ' AS ' + combinedNestedWindowFunctions[index] + ')') + ' AS' + combinedSelectedTableColumns[index].split('AS')[1] + '_' + combinedWindowFunctions[index].toLowerCase().split("($)")[0]

                } else {
                  return combinedWindowFunctions[index] + '(CAST(' + combinedSelectedTableColumns[index].split('AS')[0] + ' AS ' + combinedNestedWindowFunctions[index] + ' )) AS' + combinedSelectedTableColumns[index].split('AS')[1] + '_' + combinedWindowFunctions[index].toLowerCase()

                }
              }
              else if (combinedWindowFunctions[index].includes("$")) {
                console.log("combinedWindowFunctions with $", combinedWindowFunctions[index])
                return `${combinedWindowFunctions[index]}`.replace("$", `${combinedSelectedTableColumns[index]}`.split('AS')[0]) + "AS " + combinedSelectedTableColumns[index].split('AS')[1] + "_" + combinedWindowFunctions[index].toLowerCase().split('(')[0]
                //return `${combinedWindowFunctions[index]}(${combinedSelectedTableColumns[index]}`.split('AS')[0] + `) AS ` + combinedSelectedTableColumns[index].split('AS')[1] + "_" + combinedWindowFunctions[index].toLowerCase()
              }

              else {
                //return `${selectedWindowFn}(${combinedSelectedTableColumns[index]}`.split('AS')[0] + `) AS ` + combinedSelectedTableColumns[index].split('AS')[1] + "_" + selectedWindowFn.toLowerCase()
                return `${combinedWindowFunctions[index]}(${combinedSelectedTableColumns[index]}`.split('AS')[0] + `) AS ` + combinedSelectedTableColumns[index].split('AS')[1] + "_" + combinedWindowFunctions[index].toLowerCase()
              };
            } else if (Object.keys(combinedNestedWindowFunctions[0]).length > 0 && combinedWindowFunctions[index].length == undefined || combinedWindowFunctions[index].length === 0) {
              
              let colName;
              if (combinedSelectedTableColumns[index].includes('AS')){
                colName = combinedSelectedTableColumns[index].split('AS')[1]
              } else {
                colName = combinedSelectedTableColumns[index].split('.')[combinedSelectedTableColumns[index].split('.').length - 1]
              }
              console.log("windowFunctionWithCondition::-33", combinedNestedWindowFunctions[0],colName)
              //return 'CAST(' + combinedSelectedTableColumns[index].split('AS')[0] + ' AS ' + combinedNestedWindowFunctions[index] + ' ) AS ' + combinedSelectedTableColumns[index].split('AS')[1] + '_' + combinedNestedWindowFunctions[index].toLowerCase()
              return 'CAST(' + combinedSelectedTableColumns[index].split('AS')[0] + ' AS ' + combinedNestedWindowFunctions[index] + ' ) AS ' + colName + '_' + combinedNestedWindowFunctions[index].toLowerCase()

            }

          }
        });

        const windowFunctionsCombined = windowFunctionWithCondition.join(', ');
        //const nestedFunctionsCombined = nestedFunctionWithCondition.join(', ');
        console.log("windowFunctionWithCondition::1", windowFunctionWithCondition);
        //FUTURE REQUIREMENT
        // Define a function to get the column type based on the column name
        function getColumnType(columnName) {
          const columnInfo = columnTypeList.find(item => item[0] === columnName);
          return columnInfo ? columnInfo[1] : '';
        }
        let aliasColumnName = '';
        let matches = false;
        // Process each element in windowFunctionWithCondition
        const result = windowFunctionWithCondition.map(item => {
          if (item != undefined) {
            matches = item.match(/\(([^)]+)/); // Match text immediately after an opening parenthesis
          }
          if (matches) {
            const textAfterParenthesis = matches[1].trim();
            // Split the text by commas and asterisks to get individual column names
            const items = textAfterParenthesis.split(/[,*]/).map(column => column.trim());
            // Filter out items that are not valid column names (e.g., those containing % or ')
            const columnNames = items.filter(item => !item.includes('%') && !item.includes("'"));
            const columnTypes = columnNames.map(columnName => getColumnType(columnName));
            //console.log("aliasColumnName::1", item.includes('AS'))
            //if (item.includes('AS') && item.length>0) {
            //aliasColumnName = item.split(' AS ')[1].replace(')','');
            //} 

            return {
              columnNames,
              aliasColumnName,
              columnTypes
            };
          }
          return null;
        });

        console.log("result::11", JSON.stringify(result));
        // Remove null values from result array
        const filteredResult = result.filter(item => item !== null);

        console.log("result::22", JSON.stringify(filteredResult));

        // Apply the condition for aliasColumnsAndTypes when result is not null
        /*
        if (filteredResult.length > 0) {
          console.log("result::3",JSON.stringify(result));
          aliasColumnsAndTypes = result.map(item => [item.aliasColumnName, ...item.columnTypes.slice(0, 1)]);
        };
        */

        // FUTURE REQUIREMENT for aliascolumn type to apply for aliascolumn
        // Split the string using "AS" as the delimiter
        aliasColumnNames = windowFunctionWithCondition.map((expression) => {
          let parts = [];
          console.log(JSON.stringify(expression) + "expression::1");
          if (expression != undefined) {
            parts = expression.split(" AS ");
          }
          if (parts.length === 2) {
            return parts[1].trim();
          }
          return null; // Handle invalid expressions or return a default value
        });


        console.log("Column Names:", aliasColumnNames);


        aliasFunctionNames = windowFunctionWithCondition.map((expression) => {
          let parts = [];
          console.log(JSON.stringify(expression) + "expression::2");
          if (expression !== undefined) {
            parts = expression.split(" AS ");
          }
          if (parts.length === 2) {
            return parts[0].trim();
          }
          return null; // Handle invalid expressions or return a default value
        });

        console.log("Column Names:", aliasColumnNames);



        let overClauses;
        let partitionByValue;
        let orderByValue;

        if (combinedWindowFunctions && combinedWindowFunctions.length > 0) {
          overClauses = combinedWindowFunctions.map((windowFn, index) => {

            if (combinedPartitionBy && combinedPartitionBy.length > 0) {
              if (connectionType == 'kafka') {
                // MIN(kafka_test.tpch.customer._message_rowNumber) OVER (PARTITION BY kafka_test.tpch.customer._message_address ORDER BY kafka_test.tpch.customer._message_customerKey)
                let col_part = combinedPartitionBy[index].split('_message_')
                let col_val = 'json_extract_scalar(' + col_part[0] + '_message,' + "'$." + col_part[1] + "') AS " + '_message_' + col_part[1];
                //partitionByValue = combinedPartitionBy[index].length > 0 ? `PARTITION BY ${combinedPartitionBy[index]}` : '';
                partitionByValue = combinedPartitionBy[index].length > 0 ? `PARTITION BY ${col_val}` : '';
              } else {
                partitionByValue = combinedPartitionBy[index].length > 0 ? `PARTITION BY ${combinedPartitionBy[index]}` : '';

              }

            } else {
              partitionByValue = '';
            }
            if (combinedOrderBy && combinedOrderBy.length > 0) {
              console.log("combinedOrderBy::1", combinedOrderBy)
              orderByValue = combinedOrderBy[index].length > 0 ? `ORDER BY ${combinedOrderBy[index]}` : '';

            } else {
              orderByValue = '';
            }
            let overClause = '';
            if (orderByValue !== '' && partitionByValue !== '') {
              overClause = `OVER (${partitionByValue} ${orderByValue})`;
            } else if (orderByValue === '' && partitionByValue !== '') {
              overClause = `OVER (${partitionByValue})`;
            } else if (orderByValue !== '' && partitionByValue === '') {
              overClause = `OVER (${orderByValue})`;
            } else {
              overClause = '';
            }

            // const overClause = `OVER (${partitionByValue} ${orderByValue})`;
            return overClause;
          });
          console.log(overClauses);
        } else {

        }

        const appendWindowFunctionValues = windowFunctionWithCondition.map((func, index) => {
          if (overClauses[index] !== undefined) {
            const overClausesValue = overClauses[index] ? `${overClauses[index]}` : '';
            return `${func} ${overClausesValue}`;
          }
        });

        const appendWindowFunctionValuesFilter = appendWindowFunctionValues.filter(item => item.trim() !== 'undefined');
        //setWindowFunctionsList2(appendWindowFunctionValuesFilter)
       // windowFunctionsList2 = appendWindowFunctionValuesFilter;
        //windowFunctionsList2 = combinedSelectedTableColumns;

        //console.log("appendWindowFunctionValues::1", windowFunctionsList2);
        appendWindowFunction = appendWindowFunctionValuesFilter.join(', ');

        const overClause = `OVER(${selectPartitionByValue} ${selectOrderByValue})`;
        const appendWindowFunctionArray = windowFunctionWithCondition.map((func) => `${func} ${overClause}`);

      } else {
        windowFunctionWithColumn = '';
      }

    }
    if (!appendWindowFunction) {
      appendWindowFunction = [];
    }
    //console.log(JSON.stringify(formattedRightListOne)+"formattedRightList1");
    
    const showAdditionalGroupInputsLength = showAdditionalGroupInputs.length;
    const isSaved = false;
    //orderBy = localOrderBy;
    console.log(JSON.stringify("selectedNestedWindowFunctionValue::22", orderBy, partitionBy));
    console.log("orderBy::3", orderBy, additionalOrderByValue);
    isFilterTableValueSame = FilterTableValueSame
    console.log("isFilterTableValueSame::2", isFilterTableValueSame)
    /*
    if (connectionType == "kafka" && rightList.length ==0 ){
      rightList = leftList;
      //selectedTableColumns = leftList
      //setRightList(leftList);
      //setLeftList([]);
      //setSelectedTableColumns((prevRightList) => [...prevRightList, ...leftList])
      //leftList= []; 
      console.log("select*::1", leftList, rightList);
    }
    */
    isSelectedWindowFunction = isSelectedWindowFunction2
    //windowFunctionsList = windowFunctionsList2
    windowFunctionsList = windowFunctionWithCondition
    console.log("buildelect::-4.85", isSelectedWindowFunction, windowFunctionsList);
    onValueSubmit(selectedNodeId, name, catalog, selectedDatabase, selectedTable,
      columnDataList, leftList, formattedLeftList, formattedRightList, selectedWindowFunction,
      selectedNestedWindowFunction, appendWindowFunction,
      selectedTableColumns, orderBy, partitionBy, showWindowFunction,
      selectedAdditionalWindowFunction, selectedAdditionalNestedWindowFunction, showAdditionalGroupInputsLength,
      selectedAdditionalCounts, additionalSelectedTableColumns,
      additionalOrderBy, additionalPartitionBy  , selectedCount,
      ntileValue, ntileAdditionalValue, catalogDataList, schemaDataList,
      tableDataList, columnDataList, initialCatalogList, initialSchemaList,
      initialTableList, initialColumnList, columnTypeListValue,
      isSaved, aliasColumnNames, aliasFunctionNames, windowFunctionWithCondition,
      aliasColumnsAndTypes, columnsWithCatalogs, isFilterTableValueSame, isSelectedWindowFunction, windowFunctionsList);

  };


  const [dynamicValue, setDynamicValue] = useState('');

  // Function to update the dynamic value
  const handleNameChange = (event) => {

    setName(event.target.value);
  };

  const onDragStart = (event, column) => {

    event.dataTransfer.setData('application/reactflow', JSON.stringify(column));
    event.dataTransfer.effectAllowed = 'move';
  };
  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);

  const handleAddAll = () => {
    setRightList((prevRightList) => [...prevRightList, ...leftList]);
    setLeftList([]);
  };
  const handleRemoveAll = () => {
    setLeftList((prevLeftList) => [...prevLeftList, ...rightList]);
    setRightList([]);
  };


  const handleDeleteColumn = (columnId) => {
    setRightList((columns) => columns.filter((column) => column !== columnId));
    setLeftList((columns) => {
      const existingColumn = rightList.find((column) => column === columnId);
      if (!existingColumn) {
        return [...columns];
      }
      return [...columns, existingColumn];
    });
  };

  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const reactFlowWrapper = useRef(null);

  const onDrop = useCallback(
    (event, list) => {
      event.preventDefault();

      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const typeData = event.dataTransfer.getData('application/reactflow');
      const type = JSON.parse(typeData);

      if (!type) {
        return;
      }

      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left,
        y: event.clientY - reactFlowBounds.top,
      });


      if (list === 'left' && !leftList.find((column) => column === type)) {
        setRightList((columns) => columns.filter((column) => column !== type));
        setLeftList((columns) => [...columns, type]);
      }

      if (list === 'right' && !rightList.find((column) => column === type)) {
        setLeftList((columns) => columns.filter((column) => column !== type));
        setRightList((columns) => [...columns, type]);
        setSelectedWindowFunction((prevValues) => {
          const updatedValues = { ...prevValues };
          delete updatedValues[type]; // Remove the column if it already exists
          return updatedValues;
        });

      }
    },
    [reactFlowInstance, leftList, rightList]
  );

  const handleDropdownClick = (event) => {
    event.stopPropagation();
    setDropdownOpen(!isDropdownOpen);

  };
  const handleRefreshTables = (event) => {
    console.log(JSON.stringify(catalogList) + "--"
      + JSON.stringify(schemasList) + "--" +
      JSON.stringify(tableList) + "--" +
      JSON.stringify(columnList));
    setCatalogDataList(catalogList);
    setSchemaDataList(schemasList);
    setTableDataList(tableList);
    setColumnDataList(columnList);

    //setCatalog(catalogList[0]);
    setCatalog(connectionName);
    setSelectedDatabase(schemasList[0]);
    //setSelectedTable(selectedDatabase.tables[0]);
    const selectedTable = tableList[0]; // Change this logic based on your requirements
    setSelectedTable(selectedTable);

    console.log(JSON.stringify(selectedTable) + "selectedTableselectedTable");

    if (selectedTable) {
      setSelectedTableColumns(columnList.map(column => column[0]));

      console.log(JSON.stringify(selectedTableColumns));
      setLeftList(columnList);

      setRightList([]);
      setOrderBy(columnList[0]);
      setShowWindowFunction(false);
    }
  };

  const handleColumnOnChange = (event) => {
    const { value } = event.target;
    console.log("SelectedTableColumnsvalue::1" + value);
    setSelectedTableColumns(value);

  };

  const handleColumnOnChange2 = (event) => {
    //const { value } = event;
    console.log("SelectedTableColumnsvalue::1" + event);
    setSelectedTableColumns(event);

  };

  const handleOrderByOnChange = (event) => {
    console.log("handleOrderByOnChange::11", event)
    const { value } = event.target;
    setOrderBy(value);
  };

  const handleOrderByOnChange2 = (event) => {
    console.log("handleOrderByOnChange::11", event)
    if (event != null) {
      const { value } = event.value;
      console.log("orderBy::5", event)
      setOrderBy(event.value);
      localOrderBy = event.value
      console.log("orderBy::6", orderBy)
    }
  };

  useEffect(() => {
    console.log("orderBy::6", orderBy);
  }, [orderBy]);

  const handlePartitionByOnChange = (event) => {
    const { value } = event.target;
    console.log(value + "value");
    setPartitionBy(value);
  };
  const handlePartitionByOnChange2 = (event) => {
    if (event != null) {
      const { value } = event.value;
      setPartitionBy(value);
    }
  };
  const handleNtileOnChange = (event) => {
    const { value } = event.target;
    console.log(value + "value");
    setNtileValue(value);
  };
  const handleNtileAdditionalOnChange = (event, index) => {
    const newNtileValue = event.target.value;
    const updatedNtileAdditionalValues = [...ntileAdditionalValue];
    updatedNtileAdditionalValues[index] = newNtileValue;
    setNtileAdditionalValue(updatedNtileAdditionalValues);
  };

  const handleRemoveClick2 = () => {
    setSelectedWindowFunction('')
    setSelectedNestedWindowFunction('')
    setSelectedTableColumns('')
    setOrderBy('');
    setPartitionBy('');
    setShowWindowFunction(false);

  }
  const handleRemoveClick = (index) => {

    setShowAdditionalGroupInputs((prevGroupInputs) => {
      const updatedGroupInputs = [...prevGroupInputs];
      updatedGroupInputs.splice(index, 1); // Remove the element at the specified index
      return updatedGroupInputs;
    });
    setSelectedAdditionalWindowFunction((prevGroupInputs) => {
      const updatedGroupInputs = [...prevGroupInputs];
      updatedGroupInputs.splice(index, 1); // Remove the element at the specified index
      return updatedGroupInputs;
    });
    setSelectedAdditionalNestedWindowFunction((prevNestedGroupInputs) => {
      const updatedNestedGroupInputs = [...prevNestedGroupInputs];
      updatedNestedGroupInputs.splice(index, 1); // Remove the element at the specified index
      return updatedNestedGroupInputs;
    });
    // Clear the corresponding additional input values
    setAdditionalSelectedTableColumns((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues.splice(index, 1);
      return updatedValues;
    });

    setAdditionalOrderBy((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues.splice(index, 1);
      return updatedValues;
    });
    setNtileAdditionalValue((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues.splice(index, 1);
      return updatedValues;
    });

    setAdditionalPartitionBy((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues.splice(index, 1);
      return updatedValues;
    });

    setSelectedAdditionalCounts((prevCounts) => {
      const updatedCounts = [...prevCounts];
      updatedCounts.splice(index, 1);
      return updatedCounts;
    });
  };

  const handleAdditionalWindowFunctionChange = (event, index) => {
    const updatedOperators = [...selectedAdditionalWindowFunction];
    updatedOperators[index] = event.target.value;
    setSelectedAdditionalWindowFunction(updatedOperators);
  };

  const handleAdditionalOrderByChange = (event, index) => {
    const updatedOperators = [...additionalOrderBy];
    updatedOperators[index] = event.target.value;
    setAdditionalOrderBy(updatedOperators);
  };
  const handleAdditionalOrderByChange2 = (event, index) => {
    const updatedOperators = [...additionalOrderBy];
    console.log("handleAdditionalOrderByChange::2", event, index, updatedOperators)
    updatedOperators[index] = event;
    console.log("handleAdditionalOrderByChange::3", updatedOperators)
    setAdditionalOrderBy(updatedOperators);
    console.log("handleAdditionalOrderByChange::4", additionalOrderBy)
  };
  useEffect(() => {
    console.log("handleAdditionalOrderByChange::5", additionalOrderBy);
  }, [additionalOrderBy]);

  const handleColumnOnAdditionalChange = (event, index) => {
    const updatedOperators = [...additionalSelectedTableColumns];
    updatedOperators[index] = event.target.value;
    setAdditionalSelectedTableColumns(updatedOperators);
  };

  const handleColumnOnAdditionalChange2 = (event, index) => {
    const updatedOperators = [...additionalSelectedTableColumns];
    updatedOperators[index] = event;
    setAdditionalSelectedTableColumns(updatedOperators);
    console.log("handleColumnOnAdditionalChange2::1", additionalSelectedTableColumns,updatedOperators)
  };

  const handleAdditionalPartitionByChange = (event, index) => {
    const updatedOperators = [...additionalPartitionBy];
    updatedOperators[index] = event.target.value;
    setAdditionalPartitionBy(updatedOperators);
  };
  const handleAdditionalPartitionByChange2 = (event, index) => {
    const updatedOperators = [...additionalPartitionBy];
    updatedOperators[index] = event;
    setAdditionalPartitionBy(updatedOperators);
  };

  const renderAdditionalGroupInputs = () => {

    if (showAdditionalGroupInputs.length > 0) {
      return selectedAdditionalWindowFunction.map((input, index) => (
        <div key={index} className="additional-input">
          <div className="grid-selects">
            <div className="custom-dropdown" onClick={handleDropdownClick}>
              <label htmlFor="windowFunctionSelect" >Window Function:</label>
              <SearchableDropdown className="labelTag"
                options={windowFunctions}
                label="label"
                id="value"
                selectedVal={selectedAdditionalWindowFunction[index]}
                handleChange={(val) => {
                  console.log("val::1", val)
                  const updatedSelectedVals = [...selectedAdditionalWindowFunction];
                  console.log("val::2", JSON.stringify(updatedSelectedVals))
                  updatedSelectedVals[index] = val;
                  console.log("val::3", JSON.stringify(updatedSelectedVals))
                  setSelectedAdditionalWindowFunction(updatedSelectedVals);
                  console.log("val::4", JSON.stringify(selectedAdditionalWindowFunction))
                }}
              />
            </div>
            <div>
              <label htmlFor="windowFunctionSelect" >Nested Function:</label>
              <SearchableDropdown className="labelTag"
                options={nestedFunctions}
                label="label"
                id="value"
                selectedVal={selectedAdditionalNestedWindowFunction[index]}
                handleChange={(val) => {
                  console.log("val::1", val, selectedAdditionalNestedWindowFunction)
                  const updatedNestedSelectedVals = [...selectedAdditionalNestedWindowFunction];
                  console.log("val::2", JSON.stringify(updatedNestedSelectedVals))
                  updatedNestedSelectedVals[index] = val;
                  console.log("val::3", JSON.stringify(updatedNestedSelectedVals))
                  setSelectedAdditionalNestedWindowFunction(updatedNestedSelectedVals);
                  console.log("val::4", JSON.stringify(selectedAdditionalNestedWindowFunction))
                }}
              />
            </div>
            <div className="custom-dropdown" onClick={handleDropdownClick}>
              <label htmlFor="tableColumnSelect" >Table Column:</label>
              {selectedAdditionalWindowFunction[index] === "NTILE" ? (
                <input
                  id={`windowFunctionSelect-${index}`}
                  className="labelTag"
                  type="text"
                  value={ntileAdditionalValue[index]}
                  onChange={(event) => handleNtileAdditionalOnChange(event, index)}
                />
              ) : (
                  <SearchableDropdown className="labelTag"
                    options={orderBYCols}
                    label="value"
                    id={`tableColumnSelect-${index}`}
                    value={additionalSelectedTableColumns[index]}
                    selectedVal={additionalSelectedTableColumns[index]}
                    handleChange={(event) => handleColumnOnAdditionalChange2(event, index)}
                    isSearchable={true}
                    isClearable={true}
                  />
                )}
            </div>
            <div className="custom-dropdown" onClick={handleDropdownClick}>
              <label htmlFor="orderBySelect">Order By:</label>
              <SearchableDropdown className="labelTag"
                options={orderBYCols}
                label="value"
                id={`orderBySelect-${index}`}
                value={additionalOrderBy[index]}
                selectedVal={additionalOrderBy[index]}
                handleChange={(event) => handleAdditionalOrderByChange2(event, index)}
                isSearchable={true}
                isClearable={true}
              />
            </div>
            <div className="custom-dropdown" onClick={handleDropdownClick}>
              <label htmlFor="orderBySelect">Partition By:</label>
              <SearchableDropdown className="labelTag"
                options={orderBYCols}
                label="value"
                id={`partitionBySelect-${index}`}
                value={additionalPartitionBy[index]}
                selectedVal={additionalPartitionBy[index]}
                handleChange={(event) => handleAdditionalPartitionByChange2(event, index)}
                isSearchable={true}
                isClearable={true}
              />
            </div>
            <div>
              <input
                type="checkbox"
                id="addToSelect"
                name="addToSelect"
                onChange={(event) => handleAdditionalAddOrRemoveFromRightList(event, index)}
                //checked={rightList.includes(additionalSelectedTableColumns[index])} // Check if the value is already in rightList
                checked={isSelectedWindowFunction2?.[index+1] === true}
              />
              <label htmlFor="addToSelect">Add to select</label>
            </div>
          </div>
          <div className="form-group">
            <button
              id="addanother"
              type="button"
              className="btn btn-warning"
              onClick={() => handleRemoveClick(index)}
            >
              Remove
            </button>
          </div>
        </div>
      ));
    }
    return null;
  };



  const renderTableColumnPartitionByOptions = () => {
    var col_list = [];
    if (windowColumnDataList.includes("_message")) {
      console.log("In renderTableColumnPartitionByOptions22::", windowColumnDataList);
      col_list = windowColumnDataList
    } else {
      col_list = columnDataList
    }
    console.log("In renderTableColumnOptions33::", columnDataList)
    const columnOptions = col_list.map((column, index) => (
      <div
        key={index}
        onClick={() => handleOptionClick(column)}
        className={`option ${partitionBy.includes(column) ? 'selected' : ''}`}
      >
        {column}
      </div>
    ));
    // Include an option with an empty string value and label
    const emptyStringOption = (
      <option key="" value="">

      </option>
    );
    // Concatenate the column options and the empty string option
    return [emptyStringOption, ...columnOptions];

  };

  const renderTableColumnPartitionByAdditionalOptions = (index) => {
    var col_list = [];
    if (columnDataList.includes("_message")) {
      console.log("In renderTableColumnPartitionByAdditionalOptions22::", windowColumnDataList);
      col_list = windowColumnDataList
    } else {
      col_list = columnDataList
    }
    return col_list.map((column, colIndex) => (
      <div
        key={colIndex}
        onClick={() => handleOptionAdditionalClick(column, index)}
        className={`option ${additionalPartitionBy[index]?.includes(column) ? 'selected' : ''}`}
      >
        {column}
      </div>
    ));
  };

  const handleOptionClick = (option) => {
    // Ensure partitionBy is an array
    const updatedPartitionBy = Array.isArray(partitionBy) ? partitionBy.slice() : [];

    if (updatedPartitionBy.includes(option)) {
      // Remove the option from the array
      const filteredPartitionBy = updatedPartitionBy.filter((item) => item !== option);
      setPartitionBy(filteredPartitionBy);
      setSelectedCount(selectedCount - 1); // Decrease the selected count
    } else {
      // Add the option to the array
      updatedPartitionBy.push(option);
      setPartitionBy(updatedPartitionBy);
      setSelectedCount(selectedCount + 1); // Increase the selected count
    }
  };

  const handleOptionAdditionalClick = (option, index) => {

    setAdditionalPartitionBy((prevPartitionBy) => {
      const updatedPartitionBy = [...prevPartitionBy];
      if (updatedPartitionBy[index]) {
        if (updatedPartitionBy[index].includes(option)) {
          updatedPartitionBy[index] = updatedPartitionBy[index].filter((item) => item !== option);

        } else {
          updatedPartitionBy[index] = [...updatedPartitionBy[index], option];

        }
      } else {
        updatedPartitionBy[index] = [option];
      }
      return updatedPartitionBy;
    });

    // Update selectedAdditionalCounts based on the current selection
    setSelectedAdditionalCounts((prevCounts) => {
      const updatedCounts = [...prevCounts];
      const currentSelectedCount = additionalPartitionBy[index].length;
      updatedCounts[index] = currentSelectedCount;
      return updatedCounts;
    });
  };

  const [selectedValues, setSelectedValues] = useState([]);

  const handleInputClick = () => {

    setShowOptions(!showOptions);
  };
  const handleAdditionalInputClick = (event, index) => {
    setShowAdditionalOptions((prevOptions) => ({
      ...prevOptions,
      [index]: !prevOptions[index],
    }));
    // Update selectedAdditionalCounts based on the current selection
    setSelectedAdditionalCounts((prevCounts) => {
      const updatedCounts = [...prevCounts];
      const currentSelectedCount = additionalPartitionBy[index].length;
      updatedCounts[index] = currentSelectedCount;
      return updatedCounts;
    });
  };

  const handleAddAnotherClick = () => {
    console.log("In handleAddAnotherClick::11")
    const newSelectedAdditionalWindowFunction = [...selectedAdditionalWindowFunction, []];
    const newSelectedAdditionalNestedWindowFunction = [...selectedAdditionalNestedWindowFunction, []];
    const newAdditionalSelectedTableColumns = [...additionalSelectedTableColumns, selectedTableColumns];
    const newAdditionalOrderBy = [...additionalOrderBy, orderBy];
    setSelectedAdditionalWindowFunction(newSelectedAdditionalWindowFunction);
    setSelectedAdditionalNestedWindowFunction(newSelectedAdditionalNestedWindowFunction);
    setAdditionalSelectedTableColumns(newAdditionalSelectedTableColumns);
    setAdditionalOrderBy(newAdditionalOrderBy);
    setSelectedAdditionalWindowFunction(selectedAdditionalWindowFunction => [...selectedAdditionalWindowFunction]);
    setSelectedAdditionalNestedWindowFunction(selectedAdditionalNestedWindowFunction => [...selectedAdditionalNestedWindowFunction]);
    setAdditionalSelectedTableColumns(additionalSelectedTableColumns => [...additionalSelectedTableColumns]);
    console.log(additionalSelectedTableColumns);
    //setAdditionalOrderBy(additionalOrderBy => [...additionalOrderBy]);
    setAdditionalOrderBy(additionalOrderBy);
    console.log("orderBy::11", additionalOrderBy);
    console.log("In handleAddAnotherClick::22")
    setAdditionalPartitionBy((prevPartitionBy) => [...prevPartitionBy, []]);
    console.log("In handleAddAnotherClick::33")
    const newId = showAdditionalGroupInputs.length + 1;
    setShowAdditionalOptions((prevOptions) => ({
      ...prevOptions,
      [newId]: false,
    }));
    console.log("In handleAddAnotherClick::44", showAdditionalOptions)
    setShowAdditionalGroupInputs((prevValues) => [...prevValues, []]);
    //setSelectedAdditionalCounts((prevCounts) => [...prevCounts, 0]);
    console.log("In handleAddAnotherClick::55", showAdditionalGroupInputs, selectedAdditionalCounts)

  };

  const handleAddOrRemoveFromRightList = (e) => {
    //if (e.target.checked && selectedTableColumns && selectedWindowFunction) {
    if (e.target.checked) {
      //isSelectedWindowFunctionChecked=true
      //setIsSelectedWindowFunction2({ "first": e.target.checked})
      const updatedSelection = { ...isSelectedWindowFunction2 };
      updatedSelection[0] = true;
      setIsSelectedWindowFunction2(updatedSelection);
      console.log("buildelect::-4.75", isSelectedWindowFunction2, e.target.checked)
      //const aliasCol = selectedTableColumns + "_" + selectedWindowFunction;
      // Add to rightList if the radio button is checked
      /*
      if (selectedTableColumns && selectedWindowFunction && !rightList.includes(aliasCol)) {
      
      if (!rightList.includes(aliasCol)) {
        setRightList([...rightList, aliasCol]);
      }
      }
      */
    } else {
      //setIsSelectedWindowFunction2({ "first": e.target.checked})
      const updatedSelection = { ...isSelectedWindowFunction2 };
      updatedSelection[0] = false;
      setIsSelectedWindowFunction2(updatedSelection);
      console.log("buildelect::-4.751", isSelectedWindowFunction2, e.target.checked)
      //const aliasCol = selectedTableColumns + "_" + selectedWindowFunction;
      // Remove from rightList if the radio button is unchecked
      //setRightList(rightList.filter(item => item !== aliasCol));
    }
  };

  const handleAdditionalAddOrRemoveFromRightList = (e, index) => {
    if (e.target.checked) {
      console.log("buildelect::-4.752", isSelectedWindowFunction2, e.target.checked)
      // Add to rightList if the radio button is checked
      /*
      if (additionalSelectedTableColumns[index] && !rightList.includes(additionalSelectedTableColumns[index])) {
        setRightList([...rightList, additionalSelectedTableColumns[index]]);
      }
      */
      const key = (index+1).toString();
      const updatedSelection = { ...isSelectedWindowFunction2 };
      updatedSelection[key] = true;
      setIsSelectedWindowFunction2(updatedSelection);
    } else {
      // Remove from rightList if the radio button is unchecked
      //setRightList(rightList.filter(item => item !== additionalSelectedTableColumns[index]));
      const key =(index+1).toString();
      const updatedSelection = { ...isSelectedWindowFunction2 };
      updatedSelection[key] = false;
      setIsSelectedWindowFunction2(updatedSelection);
      console.log("buildelect::-4.753", isSelectedWindowFunction2, e.target.checked)
    }
  };

  return (
    <div className="overlay">

      <div className="popup-datatable">
        {loading && (
          <div className="overlay">
            <div className="loading-container">
              <Spinner />
              <p className="please-wait">Please wait...</p>
            </div>
          </div>
        )}
        <div className="popup-header">
          <h4 class='modal-title'>Tool Options</h4>
          <button className="close-button" onClick={onClose}>

            <span>&times;</span>
          </button>
        </div>
        <div className="datatable-content">
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="textbox">Name</label>
              <input type="text" value={name}
                className="form-control" onChange={handleNameChange}
                id="textbox" />
            </div>
            <div className="form-group">
              <label htmlFor="dropdown">List of Catalogs </label>
              <select id="database" className="form-control"
                value={catalog}
                onChange={handleCatalogChange}
                disabled={connectionType === 'SQLite'}
              >
                {renderCatalogsOptions()}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="dropdown">List of Database </label>


              <select id="database" className="form-control"
                value={selectedDatabase}
                onChange={handleDatabaseChange}
              >

                {/* {renderDatabaseOptions()}  */}
                {renderSchemasOptions()}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="dropdown">List of Table</label>

              <select id="table" className="form-control" value={selectedTable}
                onChange={(event) => handleTableChange(event, selectedTable)}
              >
                {renderTable1Options()}
              </select>

            </div>
            <button type='button' className='btn btn-primary'
              onClick={() => handleRefreshTables()}>REFRESH TABLES</button>
          </div>

          <div className="list-container">


            <div className="leftlist-container" onDragOver={onDragOver} onDrop={(event) => onDrop(event, 'left')} >

              <ul>

                {leftList.map((column) => (
                  <li
                    key={column}
                    className="blockItem ui-draggable"
                    draggable
                    onDragStart={(event) => onDragStart(event, column)}
                  >
                    {column}
                  </li>
                ))}

              </ul>
            </div>

            <ReactFlowProvider>
              <div className="" ref={reactFlowWrapper}>
                <ReactFlow
                  onInit={setReactFlowInstance}
                  onDrop={onDrop}
                  onDragOver={onDragOver}
                  fitView
                >
                  <Controls />
                </ReactFlow>
              </div>
            </ReactFlowProvider>
            <div className="rightlist-container" onDragOver={onDragOver} onDrop={(event) => onDrop(event, 'right')}>

              <ul>
                {rightList.map((column) => (
                  <li key={column} className="blockItem ui-draggable" draggable
                    onDragStart={(event) => onDragStart(event, column)}>
                    {column}

                    <button className="crossmark-button" onClick={() => handleDeleteColumn(column)}>×</button>
                  </li>

                ))}
              </ul>
            </div>

          </div>
          <div className="add-remove">
            <button type="button" className="btn btn-add" onClick={handleAddAll}>
              Add All
            </button>


            <button type="button" className="btn btn-removeall" onClick={handleRemoveAll}>
              Remove All
            </button>
          </div>

          <div className="slide-toggle-div">
            <div className="slide-toggle-button" onClick={toggleDropdowns}>
              <span>SELECT WINDOW FUNCTIONS</span>
            </div>
          </div>
          {showWindowFunction && (
            <div className="content-show-hide-div">

              <div className="content-show-hide">

                <div className="grid-selects">
                  <div className="custom-dropdown" onClick={handleDropdownClick}>

                    <div>
                      <label htmlFor="windowFunctionSelect">Window Function:</label>
                      <SearchableDropdown className="labelTag"
                        options={windowFunctions}
                        label="value"
                        id="value"
                        value={selectedWindowFunction}
                        selectedVal={selectedWindowFunction}
                        handleChange={(val) => setSelectedWindowFunction(val)}
                        isSearchable={true}  // Enable search functionality
                        isClearable={true}
                      />
                    </div>
                  </div>
                  <div className="custom-dropdown" onClick={handleDropdownClick}>
                    <div>
                      <label htmlFor="windowFunctionSelect">Nested Function:</label>
                      <SearchableDropdown className="labelTag"
                        options={nestedFunctions}
                        label="value"
                        id="value"
                        value={selectedNestedWindowFunction}
                        selectedVal={selectedNestedWindowFunction}
                        handleChange={(val) => setSelectedNestedWindowFunction(val)}
                        isSearchable={true}  // Enable search functionality
                        isClearable={true}
                      />
                    </div>
                  </div>
                  <div className="custom-dropdown" onClick={handleDropdownClick}>
                    <label htmlFor="tableColumnSelect" >Table Column:</label>
                    {selectedWindowFunction === "NTILE" ? (
                      <input
                        id="windowFunctionSelect"
                        className="labelTag"
                        type="text"
                        value={ntileValue}
                        onChange={handleNtileOnChange}
                      />
                    ) : (
                        <SearchableDropdown className="labelTag"
                          options={orderBYCols}
                          label="value"
                          id="value"
                          value={selectedTableColumns}
                          selectedVal={selectedTableColumns}
                          //handleChange={(val) => setSelectedTableColumns(val)}
                          handleChange={(event) => handleColumnOnChange2(event)}
                          isSearchable={true}
                          isClearable={true}
                        />
                      )}
                  </div>
                  <div className="custom-dropdown" onClick={handleDropdownClick}>
                    <div>
                      <label htmlFor="windowFunctionSelect">Order By:</label>
                      <SearchableDropdown className="labelTag"
                        options={orderBYCols}
                        label="value"
                        id="value"
                        value={orderBy}
                        selectedVal={orderBy}
                        handleChange={(val) => setOrderBy(val)}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                  </div>
                  <div className="custom-dropdown" onClick={handleDropdownClick}>
                    <div>
                      <label htmlFor="windowFunctionSelect">Partition By ::</label>
                      <SearchableDropdown className="labelTag"
                        options={orderBYCols}
                        label="value"
                        id="value"
                        value={partitionBy}
                        selectedVal={partitionBy}
                        handleChange={(val) => setPartitionBy(val)}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="addToSelect"
                      name="addToSelect"
                      onChange={handleAddOrRemoveFromRightList}
                      //checked={rightList.includes(`${selectedTableColumns}_${selectedWindowFunction}`)} // Check if the value is already in rightList
                      checked={isSelectedWindowFunction2?.[0]===true}
                      //checked={selectedWindowFunction}
                    />
                    <label htmlFor="addToSelect">Add to select</label>
                  </div>
                </div>
                <div className="form-group">
                  <button
                    id="addanother"
                    type="button"
                    className="btn btn-warning"
                    onClick={() => handleRemoveClick2()}
                  >
                    Remove
            </button>
                </div>
              </div>

              {renderAdditionalGroupInputs()}
              <div className="form-group">
                <button type='button' className='btn btn-primary' onClick={handleAddAnotherClick}>
                  Add Another
                </button>
              </div>
            </div>
          )}
          <div className="modal-footer">
            <button type='button' onClick={handleRemoveTable} class='btn btn-danger remove'>Delete Tool</button>
            <button type='button' className='btn btn-primary ok' onClick={handleSubmit} >OK</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataTablePopupComponent;
